import { ColorModesScale, Theme } from 'theme-ui';
import { alerts } from './alerts';
import buttons from './buttons';
import text from './text';
import { root } from './rootStyles/rootStyles';

export const baseTheme: () => Omit<Theme, 'palette'> = () => {
  return {
    alerts,
    breakpoints: [
      '0px',
      '250px',
      '500px',
      '700px',
      '1000px',
      '1260px',
      '1580px',
    ],
    buttons,
    colors: {} as ColorModesScale,
    fonts: {
      body: '"InterVariable", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif, Roboto',
      heading: 'inherit',
      monospace: 'Menlo, monospace',
    },
    fontSizes: Array(60)
      .fill(1)
      .map((_, i) => {
        return i;
      }),
    fontWeights: {
      default: 'normal',
      heading: 'bold',
    },
    forms: {},
    layout: {
      root,
    },
    lineHeights: {
      body: 1.5,
      heading: 1.125,
    },
    letterSpacings: {
      body: '0.01em',
      heading: '-0.015em',
    },
    radii: {
      alerts: 0,
      buttons: 0,
      default: '0px',
      panel: '7px',
      modals: '7px',
      tooltips: '7px',
      chatMessage: '10px',
      elementBox: '4px',
    },
    shadows: {
      default:
        'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;',
      dataGridHeader: 'rgba(0, 0, 0, 0.173) 0px 1px 7px 0px',
      modals: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;',
      tabs: '',
      panel:
        'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px',
      table:
        'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;',
      tableFilters: '1px 2px 3px rgba(0,0,0,0.2)',
      toolbar: '3px 3px 3px rgba(0,0,0,0.1)',
      desktop: {
        windowElement:
          'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
      },
      sharp: '0px 1px 1px #c7c7c7',
      neum: 'rgb(204, 219, 232) 0px 0px 5px inset, rgba(255, 255, 255, 0.5) 0px 0px 3px inset;',
    },
    space: [0, 2, 4, 8, 12, 16, 24, 32, 40, 48, 64, 80, 96, 112, 128],
    sizes: {
      // Layout
      applicationMenu: '350px',
      floatingNotifications: 'min(550px, calc(100vw - 30px))',
      root: '992px',
      mainImage: '64px',
      twoColumns: 'calc(992px + 350px)',
      twoColumnsCentered: 'calc(992px + 350px + 16px)',

      // Icons
      iconXs: '12px',
      iconSm: '16px',
      iconMd: '22px',
      iconLg: '32px',
      iconXl: '48px',
    },
    text,
    zIndices: {
      stickyElements: 600,
      menu: 1000,
      maximizedTables: 1100,
      modal: 1200,
      tooltip: 1400,
      notifications: 1600,
      contextMenu: 1800,
    },
    useRootStyles: true,
  };
};
